import type { GetTechMeansDTO } from '@/domains/disclosure/repository/disclosure-repository';
import type { GetTechMeansRequest, GoalSettingWithRecommend } from '@/domains/disclosure/types';
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { GetTechMeans } from '@/infrastructure/api-functions/core-drafting-api/get-tech-means-api';

@injectable()
export class GetTechMeansDTOImpl implements GetTechMeansDTO {
    constructor(
        @inject(GetTechMeans)
        private readonly _getTechMeansApi: GetTechMeans,
    ) {
    }

    async fetch(value: GetTechMeansRequest): Promise<GoalSettingWithRecommend> {
        const params = {
            task_id: value.taskId,
            current_step: value.currentStep,
            input: value.input,
        };

        const res = await this._getTechMeansApi.getTechMeans(params);

        return {
            inventionSubject: res.invention_subject ?? [],
            applicationField: res.application_field ?? [],
            techMeans: res.tech_means ?? '',
            techEffect: res.tech_effect ?? '',
            other: res.other ?? '',
            recommendInventionSubject: res.recommend_invention_subject ?? [],
            recommendApplicationField: res.recommend_application_field ?? [],
        };
    }
}
